export enum NotificationTab {
  Notifications = "Notifications",
  Broadcasts = "Broadcasts",
}
